import { Component, OnInit, Input  } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceService } from 'src/app/services/devices/device.service';
import { TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'app-hourly-rate',
    templateUrl: './hourly-rate.component.html',
    styleUrls: ['./hourly-rate.component.scss'],
    standalone: false
})
export class HourlyRateComponent implements OnInit {
  @Input() allSettings: boolean = false;

  selectedDuration: 'half' | 'oneHalf' | 'two' | 'custom' = 'half';
  price: number = 30;
  customHours: number = 0;
  customMinutes: number = 0;

  error: string = '';
  successMessage: boolean = false;

  serial: string = '';

  constructor(
    private _device: DeviceService,
    private _router: Router,
    private _translate: TranslateService
  ) {}

  ngOnInit(): void {
    // this.serial = this._device.getActiveDeviceSerial();
    this.loadConfig();
  }

  selectDuration(duration: 'half' | 'oneHalf' | 'two' | 'custom'): void {
    this.selectedDuration = duration;

    // Resetear valores personalizados al cambiar de tipo
    if (duration !== 'custom') {
      this.customHours = 0;
      this.customMinutes = 0;
    }
  }

  getTotalDurationDisplay(): string {
    let totalMinutes = 0;

    switch (this.selectedDuration) {
      case 'half':
        totalMinutes = 30;
        break;
      case 'oneHalf':
        totalMinutes = 60;
        break;
      case 'two':
        totalMinutes = 120;
        break;
      case 'custom':
        totalMinutes = (this.customHours * 60) + this.customMinutes;
        break;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes}min`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${minutes}min`;
    }
  }

  getPricePerHour(): string {
    let totalMinutes = 0;

    switch (this.selectedDuration) {
      case 'half':
        totalMinutes = 30;
        break;
      case 'oneHalf':
        totalMinutes = 60;
        break;
      case 'two':
        totalMinutes = 120;
        break;
      case 'custom':
        totalMinutes = (this.customHours * 60) + this.customMinutes;
        break;
    }

    if (totalMinutes === 0) return '0.00';

    const pricePerHour = (this.price / totalMinutes) * 60;
    return pricePerHour.toFixed(2);
  }

  loadConfig(): void {
    // Datos hardcodeados (temporal)
    const mockData = {
      price: 30,
      duration_minutes: 30,
      duration_type: 'half'
    };

    this.price = mockData.price;

    if (mockData.duration_minutes) {
      const minutes = mockData.duration_minutes;

      if (minutes === 30) {
        this.selectedDuration = 'half';
      } else if (minutes === 60) {
        this.selectedDuration = 'oneHalf';
      } else if (minutes === 120) {
        this.selectedDuration = 'two';
      } else {
        this.selectedDuration = 'custom';
        this.customHours = Math.floor(minutes / 60);
        this.customMinutes = minutes % 60;
      }
    }

    // Llamada original comentada
    // this._device.getModuleInfo(this.serial, 'hourly_rate').subscribe(
    //   (data) => {
    //     if (data && data.cfg) {
    //       this.price = data.cfg.price || 0;
    //
    //       if (data.cfg.duration_minutes) {
    //         const minutes = data.cfg.duration_minutes;
    //
    //         if (minutes === 30) {
    //           this.selectedDuration = 'half';
    //         } else if (minutes === 90) {
    //           this.selectedDuration = 'oneHalf';
    //         } else if (minutes === 120) {
    //           this.selectedDuration = 'two';
    //         } else {
    //           this.selectedDuration = 'custom';
    //           this.customHours = Math.floor(minutes / 60);
    //           this.customMinutes = minutes % 60;
    //         }
    //       }
    //     }
    //   },
    //   (error) => {
    //     console.error('Error loading hourly rate config:', error);
    //   }
    // );
  }

  save(): void {
    this.error = '';
    this.successMessage = false;

    // Validaciones
    if (this.price <= 0) {
      this.error = this._translate.instant('priceRequired');
      return;
    }

    if (this.selectedDuration === 'custom') {
      if (this.customHours === 0 && this.customMinutes === 0) {
        this.error = this._translate.instant('durationRequired');
        return;
      }
    }

    // Calcular duración total en minutos
    let durationMinutes = 0;
    switch (this.selectedDuration) {
      case 'half':
        durationMinutes = 30;
        break;
      case 'oneHalf':
        durationMinutes = 60;
        break;
      case 'two':
        durationMinutes = 120;
        break;
      case 'custom':
        durationMinutes = (this.customHours * 60) + this.customMinutes;
        break;
    }

    const config = {
      price: this.price,
      duration_minutes: durationMinutes,
      duration_type: this.selectedDuration
    };

    // Simulación de guardado exitoso
    console.log('Guardando configuración:', config);
    this.successMessage = true;
    setTimeout(() => {
      this.successMessage = false;
    }, 3000);

    // Llamada original comentada
    // this._device.updateModule(this.serial, 'hourly_rate', config).subscribe(
    //   (response) => {
    //     this.successMessage = true;
    //     setTimeout(() => {
    //       this.successMessage = false;
    //     }, 3000);
    //   },
    //   (error) => {
    //     this.error = this._translate.instant('errorSaving');
    //     console.error('Error saving hourly rate:', error);
    //   }
    // );
  }

  cancel(): void {
    if (!this.allSettings) {
      this._router.navigate(['/device', this.serial, 'settings']);
    } else {
      this.loadConfig();
    }
  }

}
